import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeEuropeeEuropa extends Component {
  render() {
    return (
    <div className="App">
        <EWH id="ewh-fascione-europa" repo='/elezioni/withub/electionday-2024/europee/fascione-europa.html?cid=ewh-fascione-europa&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
        <EWH id="ewh-dettaglio-europa" repo='/elezioni/withub/electionday-2024/europee/dettaglio-europa.html?cid=ewh-dettaglio-europa&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
    </div>
    )
  }
}

export default HomeEuropeeEuropa
